import React, { createContext, useContext, useState } from 'react';
import { UserDataResponse } from '../../../models/admin/users/UserDataResponse';

interface AdminUserContextType {
  selectedUserData: UserDataResponse[];
  setSelectedUserData: (data: UserDataResponse[]) => void;
}

export const AdminUserContext = createContext<AdminUserContextType | undefined>(undefined);

export const AdminUserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedUserData, setSelectedUserData] = useState<UserDataResponse[]>([]);

  return (
    <AdminUserContext.Provider value={{ selectedUserData, setSelectedUserData }}>
      {children}
    </AdminUserContext.Provider>
  );
};

export const useAdminUser = () => {
  const context = useContext(AdminUserContext);
  if (!context) throw new Error('useAdminUser must be used within AdminUserProvider');
  return context;
};
